//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";
import PostItem from '@/components/post_item/PostItem'

export default {
  created () {
    this.getPosts()
  },
  props: {
    channelId: {
      type: String,
      default: undefined
    },
    workId: {
      type: String,
      default: undefined
    },
    channelName: {
      type: String,
      default: undefined
    },
    workName: {
      type: String,
      default: undefined
    },
    isLock: {
      type: Boolean,
      default: false
    }
  },

  metaInfo () {
    return {
      // title: `${this.channelName} · ${this.workName || '西窗烛'}`,
      title: `${this.workName ? "《" + this.workName + "》" : "西窗烛"} · 内容创作`,
      titleTemplate: null,
      meta: [{
        name: "description",
        content: `${this.channelName} · ${this.workName}`
      }]
    };
  },

  data () {
    return {
      posts: null,
      page: 1,
      perPage: 5,
      loading: false
    }
  },

  scrollBottom () {
    // 当isLock为false时才能进行截下来的请求
    // 使用v-if时不需要
    if (this.isLock === undefined || this.isLock === true) {
      return
    }
    this.getPosts()
  },

  methods: {
    getPosts () {
      if (this.loading) {
        return
      }
      this.loading = true

      Post.getWorkPosts({
        workId: this.workId,
        channelId: this.channelId,
        page: this.page,
        perPage: this.perPage
      }).then((result) => {
        if (Array.isArray(result)) {
          this.posts = this.page == 1 && result || this.posts.concat(result)
          // console.log(this.posts)
          if (!this.workName) {
            this.checkTitle()
          }
          this.page += 1
          this.loading = false
        } else {
          throw new TypeError('posts is not a array')
        }
      }).catch((err) => {
        this.loading = false
      })
    },
    checkTitle () {
      if (!this.workName) {
        this.$emit('change-work-name', this.posts && this.posts[0] && this.posts[0].work.title)
      }
    }
  },

  components: {
    PostItem
  }
}



// WEBPACK FOOTER //
// ./src/pages/library/post_child_page/WorkPostPageItem.vue